import { CanDeactivate } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { QuestionnairePage } from "../../components/questionnaire/questionnaire.component";

export class QuestionnaireDeactivateGuard
  implements CanDeactivate<QuestionnairePage> {
  canDeactivate(target: QuestionnairePage): Observable<boolean> {
    if (target.isDirty()) {
      return Observable.fromPromise(target.confirmDeactivation());
    } else {
      return Observable.of(true);
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/questionnaire-deactivate/questionnaire-deactivate.guard.ts